import { render, staticRenderFns } from "./MemoryCurveDialog.vue?vue&type=template&id=0c47c57a&scoped=true"
import script from "./MemoryCurveDialog.vue?vue&type=script&lang=js"
export * from "./MemoryCurveDialog.vue?vue&type=script&lang=js"
import style0 from "./MemoryCurveDialog.vue?vue&type=style&index=0&id=0c47c57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47c57a",
  null
  
)

export default component.exports